import { useTranslation } from "react-i18next";

import { DownloadIcon, FileIcon, Trash2Icon } from "lucide-react";

import { DownloadLink } from "simplydo/react/components/DownloadLink";
import { styled } from "simplydo/react/styled";
import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";
import { Table, TableBody, TableCell, TableRow } from "simplydo/react/ui/table";

const Thumbnail = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  display: block;
`;

export type UploadedFileItem = { id: string; name?: string; url: string };

type UploadedFilesTableProps = {
  files: UploadedFileItem[];
  onRemove?: (id: string) => void;
  variant?: "file" | "image";
};

export const UploadedFilesTable = ({
  files,
  onRemove,
  variant = "file",
}: UploadedFilesTableProps) => {
  const { t } = useTranslation();

  if (!files.length) {
    return null;
  }

  return (
    <>
      <Table>
        <TableBody>
          {files.map((file) => (
            <TableRow key={file.id}>
              <TableCell collapsing>
                {variant === "image" ? (
                  <Thumbnail src={file.url} alt={file.name || ""} />
                ) : (
                  <Icon
                    icon={FileIcon}
                    size="large"
                    style={{ color: "#808080" }}
                  />
                )}
              </TableCell>
              <TableCell>
                {file.name ? (
                  <DownloadLink url={file.url} name={file.name}>
                    {file.name}
                  </DownloadLink>
                ) : null}
              </TableCell>
              <TableCell collapsing>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.25rem",
                  }}
                >
                  <DownloadLink url={file.url} name={file.name || "file"}>
                    <Button
                      size="small"
                      style={{ marginLeft: 0, marginRight: 0 }}
                      variant="outline"
                    >
                      <Icon icon={DownloadIcon} />
                      {t("generic.download")}
                    </Button>
                  </DownloadLink>
                  {onRemove ? (
                    <Button
                      onClick={() => onRemove(file.id)}
                      size="small"
                      style={{ marginLeft: 0, marginRight: 0 }}
                      variant="outline"
                    >
                      <Icon icon={Trash2Icon} />
                    </Button>
                  ) : null}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
